import { render, staticRenderFns } from "./HazardLegend.vue?vue&type=template&id=417d1bd4&scoped=true"
import script from "./HazardLegend.vue?vue&type=script&lang=js"
export * from "./HazardLegend.vue?vue&type=script&lang=js"
import style0 from "./HazardLegend.vue?vue&type=style&index=0&id=417d1bd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417d1bd4",
  null
  
)

export default component.exports